export const DESKTOP_BREAKPOINT = 768
export const LIST_ID_DESKTOP = 'compatible-products-list-desktop'
export const LIST_ID_MOBILE = 'compatible-products-list-mobile'
